export enum Category {
  Comp = 18,                      //企业
  Dep = 19,                       //部门
  User = 20,                      //用户
  IMMessage = 50,                 //消息记录
  IMGroup = 52,                   //群组
  IMGroupUser = 53,               //群组成员
  IMGroupNotice = 54,             //群通知
  IMFriends = 55,                 //好友
  IMFriendsDir = 2055,            //好友目录
  Project = 101,                  //项目
  ProjectDir = 103,               //项目目录
  Drawing = 104,                  //产品  原图纸）
  Part = 105,                     //标准件
  DrawingDir = 2104,               //产品目录
  Document = 110,                 //资料
  DocumentDir = 2110,              //资料目录
  Contact = 119,                  //通讯录
  Enterprise = 130,               //资源库
  EnterpriseDir = 2130,           //资源目录
  EnterpriseShare = 3130,         //我的资源企业共享
  EnterpriseDirShare = 3130,      //我的资源企业共享

  LectoFavoriteDir = 2131, // 产品选型参数收藏
  ResourceFavoriteDir = 2135, // 开放资源收藏

  Supplier = 131,                 //供应商
  SupplierDir = 132,              //供应商目录
  Service = 134,                  //服务商
  ServiceDir = 135,               // 服务商目录
  Outsourcing = 137,              //外协厂
  OutsourcingDir = 138,           // 外协厂目录
  OutSource = 136,                   //外协厂
  OutSourceDir = 2136,             //外协厂目录
  OutSourceDirShare = 3136,        //外协厂目录企业共享
  Prod = 260,                     //产品
  ProdDir = 264,                  //产品管理
  Tools = 300,                  //插件
  ProdFavorite = 205,             //产品收藏
  ProdFavoriteDir = 2205,         // 产品收藏目录
  News = 27,                      //企业新闻
  NewsDir = 2027,                 //企业新闻目录
  Certificate = 28,               //企业资质
  CertificateDir = 2028,          //企业资质 目录
  CompPic = 30,                   //企业图片
  Directory = 6,                  //企业图片
  WorkStation = 171,              //工作站下载
  SpecialEdition = 172,           //专用选型版本申请
  PrivateCloud = 173,           //本地化申请
  Model = 140,                     // 私有模型

  Advert = 163,                       //广告
}

export const CategoryName: any = {
  '18': "企业",//企业
  '19': "部门",//部门
  '20': "用户",//用户
  '50': "消息记录",//消息记录
  '52': "群组",//群组
  "53": "群组成员",//群组成员
  "54": "群通知",//群通知
  '260': "产品",//产品
  '119': "联系人",//PMD联系人
  '120': "通讯录",//PDM通讯录
  '300': "插件",//插件
  '104': "图纸",
  '105': "零件",
  '110': "资料",
  '130': "资源",
  '101': "项目"
};

export enum ShareArea {
  self = 1,
  dep = 2,
  depAndSub = 3,
  comp = 4
}

export const CategoryTitle: any = {
  Project: "项目",
  Drawing: "图纸库",
  Product: "产品",
  Part: "私有模型库" ,
  Document: "资料库"
};

export const WinFormStorgeKey: any = {
  ProxiesComps: 'proxies_comps', // 我代管理的企业列表
  ProxiesSelectId: 'proxies_select_id', // 当前选中的我代理的企业 
};


